<div class="ui-g-12 ui-md-6">
  <h2>{{ 'balance.giftReservation' | translate }}</h2>
</div>
<div class="ui-g-12 ui-md-6" style="text-align: right;">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g-12">
  <form>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.customer' | translate }}</span>
        <input style="width: 100%;" name="customer" type="text" pInputText class="fieldInput" [(ngModel)]="customer" disabled/>
      </div>
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.cardNo' | translate }}</span>
        <input style="width: 100%;" name="cardNo" type="text" pInputText class="fieldInput" [(ngModel)]="cardNumber" disabled/>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.acm' | translate }}</span>
        <input style="width: 100%;" name="acm" type="text" pInputText class="fieldInput" [(ngModel)]="accumulator" disabled/>
      </div>
      <!--<div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'common.store_title' | translate }}</span>
        <div class="reservation-store-dropdown-container">
          <p-dropdown
            [filter]="true"
            [options]="stores"
            [(ngModel)]="selectedStore"
            name="store"
            [disabled]="stores.length <= 1"
            [autoWidth]="false">
          </p-dropdown>
        </div>
      </div>-->
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'common.store_title' | translate }}</span>
        <div class="auto-complete">
          <app-store-autocomplete
            [(ngModel)]="selectedStore"
            ngDefaultControl
            name="store"
            [storeDetailComplete]="true"
            [selectedStore]="selectedStore"
            (selectedStoreChange)="changeStore($event)">
            [disabled]="stores.length <= 1"
          </app-store-autocomplete>
        </div>
      </div>
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'reservations.pointsBalance' | translate }}</span>
        <input style="width: 100%;" name="points" type="text" pInputText class="fieldInput" [(ngModel)]="pointsBalance" disabled/>
      </div>
    </div>
  </form>
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-4">
      <!-- Punti Spesi -->
      <span class="label">{{ 'reservations.pointsSpent' | translate }}</span>
      <input style="width: 100%;" name="point-spent" type="text" pInputText class="fieldInput" [(ngModel)]="pointsSpent" disabled/>
    </div>
    <!-- Punti Residui -->
    <div class="ui-g-12 ui-md-4">
      <span class="label">{{ 'reservations.pointsLeft' | translate }}</span>
      <input style="width: 100%;" name="points-left" type="text" pInputText class="fieldInput" [(ngModel)]="pointsLeft" disabled/>
    </div>
    <!-- Contributo -->
    <div class="ui-g-12 ui-md-4">
      <span class="label">{{ 'reservations.contribution' | translate }}</span>
      <!-- <div class="contribution-input-container">
        <input style="width: 100%;" name="contribution" type="text" pInputText class="fieldInput" [(ngModel)]="contribution" disabled/>
        <span class="contribution-currency">€</span>
      </div> -->
      <p class="contribution-value">{{ contribution.toFixed(2) }}€</p>
    </div>
  </div>
</div>
<div class="ui-g-12">
  <app-kontable
    #table
    id="gifts-table"
    title="{{ 'reservations.gifts' | translate }}"
    [columns]="[
      {field: 'catalog_desc', title: 'catalog.catalog'},
      {field: 'itm_code_host', title: 'reservations.giftCode'},
      {field: 'itm_code', title: 'catalog.itemCode'},
      {field: 'description', title: 'catalog.description'},
      {field: 'rdm_points', title: 'reservations.points'},
      {field: 'rdm_value', title: 'reservations.contribution', bodyTemplate: contributionTemplate, filterType: selectFilter, filterOptions: {values: contributionFilter}},
      {field: 'type_gift_desc', title: 'catalog.giftType', filterType: selectFilter, filterOptions: {values: giftType}},
      {field: 'reservation_type_desc', title: 'catalog.reservationType', filterType: selectFilter, filterOptions: {values: reservationType}},
      {field: 'delivery_type_desc', title: 'catalog.deliveryType', filterType: selectFilter, filterOptions: {values: deliveryTypes}}
    ]"
    [service]="giftService"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="false"
    [showConfirmGiftsBtn]="true"
    (onConfirmGifts)="confirmGifts()"
    [additionalRowCommands]="customRow"
  >
    <!-- Custom Buttons -->
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Button Rimuovi Premio -->
      <p-button
        pTooltip="{{ 'common.remove' | translate }}"
        icon="fa fas fa-minus"
        styleClass="ui-button-info"
        [disabled]="!getSelectedItemById(row.itm_id) || row.flg_state === '1'"
        (click)="removeGift(row)">
      </p-button>
      <!-- Quantità -->
      <span class="gift-qty">{{ getSelectedItemById(row.itm_id) ? getSelectedItemById(row.itm_id).qty : 0 }}</span>
      <!-- Button Aggiungi Premio -->
      <p-button
        pTooltip="{{ 'common.add' | translate }}"
        icon="fa fas fa-plus"
        styleClass="ui-button-info"
        [disabled]="row.rdm_points > pointsLeft || row.flg_state === '1' || row.reservation_type_desc.toUpperCase() === 'ON LINE'"
        (onClick)="addGift(row)">
      </p-button>
    </ng-template>
    <!-- Template Contributo -->
    <ng-template #contributionTemplate data-testid="contributionTemplate" let-row>
      <span *ngIf="row.rdm_value">{{ row.rdm_value.toFixed(2) + '€' }}</span>
    </ng-template>
  </app-kontable>

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/loyalty-gift-reservation.component.html